module.exports = __webpack_public_path__ + "3ac84471191870a0299b4414a1aa1b34.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/army-helmet-s.png
// module id = 2152
// module chunks = 0